/// <amd-module name="VC/Common/MruRouteService" />
import { Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssLocationService } from "VSS/Platform/Location";
import { IMruRouteService } from "Tfs/Platform/Interfaces";
import { GitRepository, VersionControlProjectInfo } from "VC/Common/Contracts/Git";

interface IVersionControlViewModel {
    gitRepository: GitRepository;
    projectVersionControlInfo: VersionControlProjectInfo;
}

class VCMruRouteService extends VssService implements IMruRouteService {

    /**
     * Return a Code Url that redirects based on the user's last selected repository type for the project.
     * Example URL: .../_code/?toRouteId=ms.vss-code-web.pull-request-review-route&vcType=git
     */
    public routeUrl(routeValues: {[routeValue: string]: any }, hostPath?: string): string {
        const locationService = this.pageContext.getService<IVssLocationService>("IVssLocationService");
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const vcViewModel = contributionService.getData<IVersionControlViewModel>("ms.vss-code-web.versioncontrol-viewmodel-data-provider");

        if (vcViewModel) {
            if (vcViewModel.gitRepository) {
                routeValues.vcType = "git";
            }
            else if (vcViewModel.projectVersionControlInfo && vcViewModel.projectVersionControlInfo.supportsTFVC) {
                routeValues.vcType = "tfvc";
            }
        }

        return locationService.routeUrl("ms.vss-code-web.code-redirect", routeValues, hostPath);
    }

    public readonly id = "vc-mru-route-service";
}

Services.add("vc-mru-route-service", { serviceFactory: VCMruRouteService });
